export const getIsLoggedIn = state => state.auth.isLogin;
export const getToken = state => state.auth.accessToken;
